module.exports = __webpack_public_path__ + "static/media/graphOff_326.4fc6a6de.png";